import React, { useCallback } from 'react';

import { NotificationManager, printMissingConfigError, SiteConfigManager } from '@atlas/core';

import ConfirmPopup from 'common/Popup/ConfirmPopup';
import StaticBlock from 'common/StaticBlock/StaticBlock';
import history from 'components/MainRouter/history';

const ResponsibleGamingPopup = ({ data: { onClose = () => {} } = {}, id }) => {
  const block = SiteConfigManager.getConfig(
    'config.config.responsible_gaming.popup_static_block_name',
  );
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
    onClose();
  }, [id, onClose]);

  const moreHandler = useCallback(() => {
    history.push('/account/responsible-gaming/self-regulation');
    handleClose();
  }, []);

  if (!block) {
    printMissingConfigError('config.config.responsible_gaming.popup_static_block_name');
  }

  return (
    <ConfirmPopup
      data={{
        onClose: handleClose,
        onConfirm: moreHandler,
        confirmLabel: 'more',
        closeLabel: 'close',
        className: 'responsible-gaming-sign-in',
      }}
    >
      <StaticBlock options={{ source: block }} />
    </ConfirmPopup>
  );
};

export default ResponsibleGamingPopup;
